export default __webpack_public_path__ + "static/media/BG.e9703a56.svg";